import type { EventDetails } from "@/modules/events/types/eventDetailsApi"
import type { NextRequest } from "@/modules/fetch/types"
import type { I18nLocale } from "@/modules/i18n/types"

import { getResultFromResponse } from "@/modules/apiRequests/handlers"
import { EVENT_DETAILS_PATH } from "@/modules/events/constants/api"
import { handleFetchError } from "@/modules/fetch/errorHandler"
import { fetcher } from "@/modules/fetch/fetcher"
import { toCamelCaseKeys } from "@/modules/format/object/toCamelCaseKeys"

type EventDetailsParams = {
  hostname: string
  locale: I18nLocale
  nextRequest?: NextRequest
  slug: string
}

export const getEventDetails = async (params: EventDetailsParams): Promise<EventDetails> => {
  const { locale, hostname, slug, nextRequest } = params

  return fetcher(`/${locale}${EVENT_DETAILS_PATH}${slug}`, {
    hostname,
    nextRequest,
    requestInit: {
      headers: {
        "Accept-Language": locale,
      },
    },
    serviceDomain: "MONOLITH_API",
    storageDuration: 0,
    storageKey: `event-details::${slug}::${locale}`,
  })
    .then(getResultFromResponse<EventDetails>({ transformResult: toCamelCaseKeys }))
    .catch(handleFetchError(`${EVENT_DETAILS_PATH}${slug}`))
}
